<div class="viewer bpmn-viewer-background" [ngClass]="(userSelectionInProgress | async) ? 'wait-for-click': 'clickable'">
        <notification-container [position]="BANNER_LOCAL" [key]="GUIDED_BOX_CHANNEL" [styleClass]="showMultipleGuideBox ? 'pt-notification-banner-local-slim' : ''"
                                maxMessageCount="{{ messageCount }}"></notification-container>
    <gen-overlay-loader class="loader" *ngIf="spinnerActive" [showOverlay]="true"></gen-overlay-loader>
    <div id="js-canvas" [ngClass]="{'hide-bpmn-logo':hideBpmnLogo}"></div>
</div>

<div class="bottom-wrapper">
    <div class="icon-container">
    <span class="menu-bar icon__plus-zoom-in" (mousedown)="zoomInCanvas()"><span class="path1"></span><span
            class="path2"></span></span>
    </div>
    <div class="icon-container">
    <span class="menu-bar icon__plus-zoom-out" (mousedown)="zoomOutCanvas()"><span class="path1"></span><span
            class="path2"></span></span>
    </div>
    <div class="icon-container">
    <span class="menu-bar icon__zoom-in1" (mousedown)="recenter()"><span class="path1"></span><span
            class="path2"></span></span>
        <span class="icon-label">Go to selected node</span>
    </div>
    <div class="icon-container">
    <span class="menu-bar  icon__fit-to-screen" (mousedown)="topView()"><span class="path1"></span><span
            class="path2"></span></span>
        <span class="icon-label">Fit to screen</span>
    </div>
</div>

<ng-template let-messageContainer #messageTemplate>
    <div class="pt-notification-item-content">
        <div id="automation-guide-notes-provider"
             [ngClass]="textFitInScreen ? 'pt-notification-item-template-content' : 'pt-notification-item-template-content-long-line'"
             [innerHTML]="messageContainer.body">
        </div>
    </div>
    <footer *ngIf="messageContainer.buttons">
        <ng-container *ngFor="let button of messageContainer.buttons">
            <button dlsButton class="pt-quiet-default pt-button"
                    *ngIf="button.label === 'Close'"
                    (click)="messageService.clearMessage(messageContainer)">{{button.label}}</button>
            <div *ngIf="button.label !== 'Close' && !messageContainer.hasAttachments" class="icon-attachment-placeholder"></div>
            <button *ngIf="button.label !== 'Close'" dlsButton class="pt-quiet-default pt-button "
                    (click)="button.action()">
                <div>
                    <i *ngIf="messageContainer.hasAttachments" class="icon__attachment"></i>
                </div>
                {{button.label}}</button>
        </ng-container>
    </footer>
</ng-template>
